// useUnsavedChangesAlert.js
import { useEffect, useContext } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

export function useUnsavedChangesAlert(unsavedChanges) {
  // 1. Handle browser reload/close
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (unsavedChanges) {
        event.preventDefault();
        event.returnValue = ''; // required for Chrome
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [unsavedChanges]);

  // 2. Handle internal React Router navigation
  const { navigator } = useContext(UNSAFE_NavigationContext);

  useEffect(() => {
    if (!unsavedChanges) return;

    const push = navigator.push;
    navigator.push = (...args) => {
      const confirmLeave = window.confirm(
        'You have unsaved changes. Do you really want to leave?'
      );
      if (confirmLeave) {
        navigator.push = push; // restore
        navigator.push(...args);
      }
    };

    return () => {
      navigator.push = push; // cleanup
    };
  }, [unsavedChanges, navigator]);
}
